import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../../Config/Config";

export const fetchRoleData = createAsyncThunk(
  "api/fetchCreateRole",
  async () => {
    const response = await fetch(
      `${FULL_API_BASE_URL}/get-role-screen-access_all/`
    );
    const data = await response.json();
    return data;
  }
);

const createRoleSlice = createSlice({
  name: "createRole",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoleData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRoleData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchRoleData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default createRoleSlice.reducer;
